<template>
  <div>
    <el-main>
      <el-form ref="queryForm" :inline="true" class="form-search" :model="queryForm">
        <el-row>
          <el-form-item label="操作员姓名：" prop="name">
            <el-input v-model="queryForm.name" />
          </el-form-item>
          <el-form-item label="手机号：" prop="tel">
            <el-input v-model="queryForm.tel" />
          </el-form-item>
          <el-button type="primary" @click="queryInfo">查询</el-button>
          <el-button @click="resetForm('queryForm')">重置</el-button>
        </el-row>
        <el-row>
          <el-button type="primary" size="mini" @click="addUser()">新建操作员</el-button>
        </el-row>
      </el-form>
      <el-table
        border
        style="margin-top:20px;margin-bottom:20px"
        class="common-list"
        :data="tableList"
      >
        <el-table-column label="序号" type="index" />
        <el-table-column label="创建时间" prop="createTime" />
        <!-- <el-table-column label="登录名" prop="" /> -->
        <el-table-column label="姓名" prop="name" />
        <!-- <el-table-column label="所属角色" prop="roleName" /> -->
        <el-table-column label="手机号" prop="phoneMask" />
        <el-table-column label="账户状态" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status=='01'">正常</span>
            <span v-if="scope.row.status=='02'">冻结</span>
            <span v-if="scope.row.status=='03'">删除</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.adminFlag=='02'" type="text" size="mini" @click="handleRole(scope.row.userId)">角色</el-button>
            <el-button type="text" size="mini" @click="checkOperator(scope.row.id)">查看</el-button>
            <el-button type="text" size="mini" @click="editOperator(scope.row)">修改</el-button>
            <el-button type="text" size="mini" @click="removeOperator(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :current-page="page"
        :limit.sync="size"
        @pagination="queryInfo"
      />
    </el-main>
    <!-- 新增操作员 -->
    <el-dialog :visible.sync="addDialog" :title="dialogName" @close="addDialogClose">
      <el-form ref="addForm" :inline="true" class="form-search" :model="addForm" :rules="addRules">
        <el-row>
          <el-form-item v-if="!changeFlag" label="姓名：" prop="name">
            <el-input v-if="editFlag" v-model="addForm.nameMask" :disabled="editFlag" />
            <el-input v-else v-model="addForm.name" :disabled="editFlag" />
            
          </el-form-item>
          <el-form-item v-if="!changeFlag" label="手机号：" prop="tel">
            <el-input v-if="editFlag" v-model="addForm.phoneMask" :disabled="editFlag" />
            <el-input v-else v-model="addForm.tel" :disabled="editFlag" />
            
          </el-form-item>
          <el-form-item v-if="!changeFlag" label="身份证号：" prop="idCard">
            <el-input v-if="editFlag" v-model="addForm.idCardNoMask" :disabled="editFlag" />
            <el-input v-else v-model="addForm.idCard" :disabled="editFlag" />
          </el-form-item>
          <el-form-item v-if="addressFlag" label="所属地区：" class="area_width" prop="poscasAdd">
            <Liareaselect
              ref="clearupArea"
              label-width="150"
              :is-show="false"
              :list="listData"
              :is-dis="false"
              @listenPro="address"
              :provinceId="listData.province.id"
              :cityId="listData.city.id"
              :areaId="listData.area.id"
            />
          </el-form-item>
          <el-form-item label="操作员状态：" prop="status">
            <el-radio-group v-model="addForm.status">
              <el-radio label="01" :disabled="editFlag">正常</el-radio>
              <el-radio label="02" :disabled="editFlag">冻结</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="选择角色：" prop="roleId">
            <el-select v-model="addForm.roleId" placeholder="请选择">
              <el-option
                v-for="item in rolesList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
        <!-- <el-row> -->
          <div v-if="!editFlag" style="display: inline-block;margin-right:10px">
            <el-button v-if="addressFlag" type="primary" @click="createOperator('2')">创建操作员</el-button>
            <el-button v-else type="primary" @click="createOperator('1')">提交</el-button>
          </div>

          <el-button @click="addDialog=false">返回</el-button>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 角色 -->
    <el-dialog :visible.sync="dialogVisible" title="编辑 角色">
      <el-form :model="role" label-width="80px" label-position="left">
        <el-form-item label="角色">
          <el-tree ref="tree" :check-strictly="checkStrictly" :data="roleTree" :props="defaultProps" :default-checked-keys="defaultCheckedKeys" :filter-node-method="filterNode" show-checkbox node-key="id" class="role-tree" />
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="dialogVisible=false">
          返回
        </el-button>
        <el-button v-if="showButton" type="primary" @click="confirmRole">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { SignOnClick, SelectCertificateOnClick } from "@/utils/CryptoKit"
import { getInfo, createInfo, removeInfo, checkInfo, searchUserRole, editInfo, codeRoleSelect, changeUserRole } from '@/api/merService/operator'
import { merchantRoleSearch } from '@/api/merService/role'
import idNoCheck from '@/utils/saas/idNoCheck'
import { VDATA } from '@/utils/saas/validate'
import CommonApi from '@/api/common/common'
import Liareaselect from '@/components/Liareaselect'
import Pagination from '@/components/Pagination' // 分页
const defaultRole = {
  key: '',
  name: '',
  description: '',
  routes: []
}
export default {
  name: 'Operator',
  components: {
    Liareaselect,
    Pagination
  },
  data() {
    return {
      rolesList: [],
      page: 1,
      size: 10,
      total: 0,
      addDialog: false,
      dialogVisible: false,
      checkStrictly: false,
      showButton: false,
      addressFlag: true,
      editFlag: false,
      dialogName: '新增操作员',
      queryForm: {
        name: null,
        tel: null
      },
      tableList: [],
      changeFlag: false,
      defaultCheckedKeys: [],
      role: Object.assign({}, defaultRole),
      roleTree: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        id: 'id'
      },
      listData: {
        province: { id: null, name: null }, // 省
        city: { id: null, name: null },
        area: { id: null, name: null }
      },
      addForm: {
        name: null,
        tel: null,
        idCard: null,
        personProvNo: null,
        personProv: null,
        personCityNo: null,
        personCity: null,
        poscasAdd: null,
        status: '01',
        idCardNoMask: null,
        phoneMask: null,
        nameMask: null,
        roleId: null
      },
      currOperId: null,
      currtel: null,
      addRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const vdt = VDATA(value, {
                elevenphone: {
                  msg: '请输入正确的手机号格式'
                }
              })
              if (!vdt.result) {
                callback(new Error(vdt.msg))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        idCard: [
          { required: true, message: '请输入身份证', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入身份证'))
              } else if (!idNoCheck.isIdno(value)) {
                callback(new Error('请输入正确的身份证'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }

        ],
        poscasAdd: [
          { required: true, message: '请输入选择地址', trigger: 'blur' }
        ]
      },
      user: {
        id: undefined
      },
      userId: null
    }
  },
  computed: {
    merNo() {
      return this.$store.state.user.merNo
    }
  },
  created() {
    this.getRoles()
    this.searchRoleData()
  },
  methods: {
    searchRoleData() {
      const param = {
        page: 1,
        size: 9999,
        platform: 'merchant',
        merchantNo: this.merNo
      }
      merchantRoleSearch(param).then(response => {
        this.rolesList = response.data.list
      })
    },
    // 查询
    queryInfo() {
      // const param = Object.assign(this.queryForm, { pageNum: this.page, pageSize: this.size, merNo: Session.getItem('merNo') })
      const param = Object.assign({}, this.queryForm, { pageNum: this.page, pageSize: this.size, merNo: this.merNo })
      let signKeys = ['name', 'tel']
      param.isCfcaDecrypt = SelectCertificateOnClick() ? true : false
      for (const item of signKeys) {
        if (this.queryForm[item]) {
          data = this.queryForm[item]
          param[item] = SignOnClick(this.queryForm[item]).result
        }
      }
      getInfo(param).then(res => {
        // console.log(res)
        this.tableList = res.data.list
        this.size = res.data.size
        this.page = res.data.page
        this.total = res.data.total
      })
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    createOperator(type) {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          let param
          // console.log(this.addForm)
          if (this.currOperId) {
            // param = Object.assign(this.addForm, { merNo: Session.getItem('merNo'), operId: this.currOperId, oldTel: this.currtel })
            param = Object.assign(this.addForm, { merNo: this.merNo, operId: this.currOperId, oldTel: this.currtel })
          } else {
            // param = Object.assign(this.addForm, { merNo: Session.getItem('merNo') })
            param = Object.assign(this.addForm, { merNo: this.merNo })
          }
          let signKeys = ['name', 'tel', 'idCard']
          param.isCfcaDecrypt = SelectCertificateOnClick() ? true : false
          for (const item of signKeys) {
            if (this.addForm[item]) {
              param[item] = SignOnClick(this.addForm[item]).result
            }
          }
          if (type === '1') {
            param.userId = this.userId
            editInfo(param).then(res => {
              this.$message.success('修改成功')
              this.addDialog = false
              this.queryInfo()
            })
          } else {
            createInfo(param).then(res => {
              // console.log(res)
              this.$message.success('创建成功')
              this.addDialog = false
              this.queryInfo()
            })
          }
        }
      })
    },
    addUser() {
      this.editFlag = false
      this.changeFlag = false
      this.addressFlag = true
      this.addDialog = true
      this.listData = {
        province: { id: null, name: null }, // 省
        city: { id: null, name: null },
        area: { id: null, name: null }
      }
    },
    // 省市区监听
    address(data) {
      if (!data.province.name || !data.city.name) {
        this.addForm.poscasAdd = null
      } else {
        this.addForm.poscasAdd = true
      }
      this.addForm.personProvNo = data.province.id
      this.addForm.personProv = data.province.name
      this.addForm.personCityNo = data.city.id
      this.addForm.personCity = data.city.name
    },
    addDialogClose() {
      if (this.addForm.poscasAdd) {
        this.$refs.clearupArea.emptyData()
      }
      this.resetForm('addForm')
      this.dialogName = '新增操作员'
      for (const key in this.addForm) {
        if (key === 'status') {
          this.addForm[key] = '01'
        } else {
          this.addForm[key] = null
        }
      }
    },
    // 修改操作员
    editOperator(scope) {
      this.dialogName = '修改'
      this.changeFlag = true
      this.currOperId = scope.id
      this.userId = scope.userId
      this.checkOperator(scope.id, '1')
    },
    // 删除操作员
    removeOperator(operId) {
      const param = { operId: operId }
      removeInfo(param).then(res => {
        // console.log(operId)
        this.$message.success('删除成功')
        this.queryInfo()
      })
    },
    // 查看操作员
    checkOperator(operId, type) {
      this.dialogName = '查看'
      this.addressFlag = false
      const param = { operId: operId }
      checkInfo(param).then(res => {
        if (type === '1') {
          this.currtel = res.data.tel
          this.editFlag = false
        } else {
          this.editFlag = true
          this.changeFlag = false
        }

        this.addForm.name = res.data.name
        this.addForm.tel = res.data.tel
        this.addForm.idCard = res.data.idCardNoMask
        this.addForm.status = res.data.status
        this.addForm.idCardNoMask = res.data.idCardNoMask
        this.addForm.phoneMask = res.data.phoneMask
        this.addForm.nameMask = res.data.nameMask
        this.addForm.roleId = res.data.roleId
        if (res.data.roleId == '114') {
          const newObj = {id: '114', name: res.data.roleName}
          this.rolesList.push(newObj)
          this.duplicateRemoval(this.rolesList)
        } else {
          const flag = this.rolesList.every(item => {
            return item.id != '114'
          })
          if (!flag) {
            this.rolesList.pop()
          }
        }
        this.addDialog = true
      })
    },
    // 去重
    duplicateRemoval(arr) {
      for (let i = 0; i < arr.length; i++) {
        for (let j = i+1; j < arr.length; j++) {
          if (arr[i].id === arr[j].id) {
            arr.splice(j,1)
            j--
          }
        }
      }
    },
    async handleRole(userId) {
      this.user.id = userId
      const response = await searchUserRole({ userId: userId, size: 9999 })
      const userRoleList = response.data.list
      // console.log(response.data.list)

      if (response.data.list.length > 1) this.showButton = true
      this.roleIds = []
      userRoleList.forEach((item) => {
        // console.log(item)
        this.roleIds.push(item.roleId)
      })
      // console.log(this.roleIds)
      this.checkedKeys = this.roleIds
      this.dialogVisible = true
      this.checkStrictly = true
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.checkedKeys)
        this.$refs.tree.filter('merchant')
        this.checkStrictly = false
      })
    },
    async getRoles() {
      // const param = { code: 'merchant', platformId: 5, merchantNo: Session.getItem('merNo') }
      const param = { code: 'merchant', platformId: 5, merchantNo: this.merNo }
      const response = await CommonApi.codeRoleSelect(param)
      this.roleTree = response.data.children
      if (response.data.children.length > 0) this.showButton = true

      // console.log(this.roleTree)
    },
    confirmRole() {
      const checkedKeys = this.$refs.tree.getCheckedKeys()
      // eslint-disable-next-line no-unused-vars
      const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys()
      // const roleIds = checkedKeys.concat(halfCheckedKeys)
      const roleIds = checkedKeys
      // console.log('查看长度roleIds')
      // console.log(roleIds.length < 1)
      // console.log(roleIds)
      if (roleIds.length < 1) {
        this.$message({
          type: 'warning',
          message: '请选择角色'
        })
        return false
      }
      changeUserRole({ userId: this.user.id, roleIds: roleIds }).then(response => {
        // console.log(response)
        this.$message({
          type: 'success',
          message: 'Change User Role succed!'
        })
        this.dialogVisible = false
      }).catch(error => {
        console.error(error)
      })
    },
    filterNode(value, data, node) {
      return data.code.toString().startsWith(value)
    }
  }
}
</script>

<style scoped>

</style>
